export const PAY_INSTANTLY_SUBTEXT_TURBO_WIDGET = "Pay Instantly";
